<template lang="pug">
  .shipping-settings
    v-container(style="max-width:600px")
      //- Shipping zone
      v-card.py-4.mt-4(flat outlined)
        div.px-4.pb-4
          div.s1.basic800--text {{ $t('section_title_zone') }}
          div.c1.basic600--text {{ $t('section_desc_zone') }}
          a.c1.accent--text.text-decoration-none(href="https://help.yezza.io/hc/en-my/articles/900003730746-How-To-Setup-Manual-Delivery" target="_blank") {{ $t('learn_more') }}
        delivery-zone-list(:open.sync="openManageDeliveryZoneDialog" :company="company" :couriers="couriers")

      //- Courier integration
      v-card.pt-4.mt-4(flat outlined)
        div.px-4.pb-4
          div.s1.basic800--text {{ $t('section_title_courier') }}
          div.c1.basic600--text {{ $t('section_desc_courier') }}
          a.c1.accent--text.text-decoration-none(href="https://help.yezza.io/hc/en-my/articles/900003734966-How-To-Integrate-Easyparcel-Delivery" target="_blank") {{ $t('learn_more') }}
        v-row.grey.lighten-3.py-2(no-gutters)
          v-col.px-4(cols="6" md="8")
            p.text-body-2.mb-0.grey--text.text--darken-1.font-weight-bold {{ $t('service') }}
          v-col
            p.text-body-2.mb-0.grey--text.text--darken-1.font-weight-bold {{ $t('activate') }}
        template(v-if="courierData.name !=='YezzaShipping'" v-for="(courierData, courier) in couriers")
          div(v-if="courierData.category == 'courier'")
            v-row.py-4(no-gutters)
              v-col.px-4(cols="6" md="8")
                div.s1.basic800--text {{ courierData.name }}
                div.c1.basic600--text {{ $t(`courier_description.${courier}`) }}
                //-p.text-body-2.mb-0.font-weight-bold {{ courierData.name }}
                //-p.text-caption.mb-0.grey--text.text--darken-1 {{ $t(`courier_description.${courier}`) }}
              v-col.shrink
                y-switch.ma-0.pa-0(v-model="courierData.enabled" :disabled="courierData.id == null" @change="toggleCourier(courier)")
              v-col(align="center")
                v-chip.button-AA-tiny(label outlined small color="black" @click="openCourier(courier)") {{ courierData.id == null ? 'Setup' : 'Manage'}}
            //-v-divider

      //- On demand delivery
      v-card.pt-4.mt-4(flat outlined)
        div.px-4.pb-4
          div.s1.basic800--text {{ $t('section_title_ondemand') }}
          div.c1.basic600--text {{ $t('section_desc_ondemand') }}
          a.c1.accent--text.text-decoration-none(href="https://help.yezza.io/hc/en-my/articles/900004927963-How-To-Integrate-Lalamove-Delivery" target="_blank") {{ $t('learn_more') }}
        v-row.grey.lighten-3.py-2(no-gutters)
          v-col.px-4(cols="6" md="8")
            p.text-body-2.mb-0.grey--text.text--darken-1.font-weight-bold {{ $t('service') }}
          v-col
            p.text-body-2.mb-0.grey--text.text--darken-1.font-weight-bold {{ $t('activate') }}
        template(v-for="(courierData, courier, index) in couriers")
          div(v-if="courierData.category == 'on-demand'")
            v-row.py-4(no-gutters)
              v-col.px-4(cols="6" md="8")
                div.s1.basic800--text {{ courierData.name }}
                div.c1.basic600--text {{ $t(`courier_description.${courier}`) }}
              v-col.shrink
                y-switch.ma-0.pa-0(v-model="courierData.enabled" :disabled="courierData.id == null" @change="toggleCourier(courier)")
              v-col(align="center")
                v-chip.button-AA-tiny(label outlined small color="black" @click="openCourier(courier)") {{ courierData.id == null ? 'Setup' : 'Manage'}}
            v-divider(v-if="index<2")
      v-layout.mt-8
        v-chip.mx-auto(outlined @click="openLink")
          template(v-slot:default)
            v-layout.ma-2
              div.p2 {{ $t('learn_more_about') }}
              a.ml-1.p2.textColorAccent--text.text-decoration-none(href="https://help.yezza.io/hc/en-my/sections/900000567906-Delivery-Setup" target="_blank") {{ $t('shipping') }}
</template>

<script>
import { mapActions } from 'vuex'
import DeliveryChargeList from '@/components/dialogs/settings/DeliveryChargeList.vue'
import DeliveryZoneList from '@/components/dialogs/settings/DeliveryZoneList.vue'

export default {
  name: 'ShippingSettings',
  components: { DeliveryChargeList, DeliveryZoneList },
  props: ['company'],
  data () {
    return {
      invoiceSettings: null,
      showUpdateDeliveryChargeDialog: false,
      openManageDeliveryZoneDialog: false,
      couriers: []
    }
  },
  mounted () {
    this.fetchShippingSettings()
  },
  methods: {
    ...mapActions([
      'showMessage'
    ]),
    openLink () {
      window.open('https://guide.yezza.io/docs-category/shipping/')
    },
    toggleCourier(courier) {
      const data = {'enabled': this.couriers[courier].enabled}
      this.axios.patch(`/shipping/settings/${this.company.slug}/${courier}`, data)
        .then(() => {
          const shipments = {
            easyparcel: this.couriers.easyparcel.enabled,
            zepto: this.couriers.zepto.enabled,
            lalamove: this.couriers.lalamove.enabled,
            yscourier: false,
            yslocaldelivery: false
          }
          this.$store.commit('orders/setShipments', shipments)
        })
        .catch(() => {
          this.showMessage(['error', this.$t('error_message.unable_to_complete_request')])
      })
    },
    openCourier (courier) {
       
      if (courier === 'easyparcel') {
        this.$router.push('/admin/settings/easyparcel')
      } else if (courier === 'zepto') {
        this.$router.push('/admin/settings/zeptoexpress')
      } else if (courier === 'lalamove') {
        this.$router.push('/admin/settings/lalamove')
      }
    },
    getAvailability (index) {
      return this.couriers[index].available
    },
    fetchShippingSettings () {
      this.$axios.get(`/shipping/settings/${this.company.slug}`).then((response) => {
        this.couriers = response.data.couriers
      },()=>{})
    }
  }
}
</script>

<i18n>
{
  "en": {
    "settings_title": "Shipping & Delivery",
    "section_title_zone": "Manage shipping & delivery methods by zones",
    "section_desc_zone": "Manage shipping & delivery methods by zones",
    "section_title_courier": "Courier Integration",
    "section_desc_courier": "Take advantage of courier services that can easily integrated with your Yezza account",
    "section_title_ondemand": "On-Demand Delivery Integration",
    "section_desc_ondemand": "Take advantage of on-demand delivery services that can easily integrated with your Yezza account",
    "courier_description": {
      "easyparcel": "Hub for major courier services like PosLaju, DHL etc.",
      "lalamove": "On-Demand service delivery in Malaysia",
      "zepto": "On-Demand service delivery in Malaysia"
    }
  },
  "id": {
    "settings_title": "Shipping & Delivery",
    "section_title_zone": "Atur shipping & delivery berdasarkan zona",
    "section_desc_zone": "Atur shipping & delivery berdasarkan zona",
    "section_title_courier": "Integrasi Kurir",
    "section_desc_courier": "Manfaatkan layanan kurir yang mudah diintegrasikan dengan akun Yezza kamu",
    "section_title_ondemand": "Integrasi Pengiriman Sesuai Permintaan",
    "section_desc_ondemand": "Manfaatkan layanan pengiriman sesuai permintaan yang dengan mudah diintegrasikan dalam akun Yezza kamu.",
    "courier_description": {
      "easyparcel": "Hub untuk layanan kurir utama seperti PosLaju, DHL dll.",
      "lalamove": "Pengiriman layanan sesuai permintaan di Malaysia",
      "zepto": "Pengiriman layanan sesuai permintaan di Malaysia"
    }
  }
}
</i18n>